<template>
	<v-app-bar color="secondary" dark dense :clipped-left="$vuetify.rtl" :clipped-right="!$vuetify.rtl" style="height: 68px;padding:10px 0">
		<v-toolbar-title>
			<img @click="routeToPlans" src="/logo-wide.png" style="float: right;max-width: 100px;max-height: 40px;cursor:pointer" />
			<strong class="mr-1 font-weight-black hidden-sm-and-down pt-1">{{ businessTitle }}</strong>
			<h5 class="mr-1 font-weight-black hidden-md-and-up pt-2" style="width:500px">{{ businessTitle }}</h5>
			&nbsp;
			<!-- <span class="orange--text">جت اقساط</span> -->
		</v-toolbar-title>
		<v-spacer />
		<div>
			<v-menu>
				<template v-slot:activator="{ on, attrs }">
					<v-btn fab color="white" elevation="0" dark small v-bind="attrs" v-on="on">
						<v-icon color="secondary">mdi-account-outline</v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item link>
						<v-list-item-title @click="goToLogin">ورود به پنل کاربری</v-list-item-title>
					</v-list-item>
					<v-list-item link>
						<v-list-item-title @click="goToRegister">عضویت</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
			<a class="hidden-sm-and-down" v-if="landingSettings && landingSettings.applicationLink" :href="landingSettings.applicationLink">
				<v-btn class="mr-2 px-2" small>
					<v-img height="30" width="30" class="ml-1" src="/android.webp">
					</v-img>
					دانلود اپلیکیشن
				</v-btn>
			</a>
			<a class="hidden-sm-and-down" :href="shopLink" v-if="shopLink" target="_blank">
				<v-btn class="mr-2 black--text" small rounded color="white">
					<v-icon left>mdi-cart</v-icon>
					{{ shopTitle }}
				</v-btn>
			</a>
			<v-btn @click="toggleEditMode" v-if="isAdmin" class="" fab text small>
				<v-icon>mdi-pencil-box-outline</v-icon>
			</v-btn>
		</div>
	</v-app-bar>
</template>

<script>
import { get, call } from 'vuex-pathify'
import router from '@/router'
// Utilities

export default {
	name: 'LandingAppBar',

	components: {

	},
	data() {
		return {

		}
	},
	computed: {
		...get('siteConfig', [
			'longTitle', 'isCloud'
		]),
		...get('appSettings', [
			'landingSettings'
		]),
		...get('auth', [
			'isAdmin', 'getCurrentUser'
		]),
		...get('app', [
			'editMode'
		]),
		showRegisterBtn() {
			return (!this.isCloud || (this.isCloud && this.$route.params.customerCode)) && !this.getCurrentUser
		},
		businessTitle() {
			return this.landingSettings?.businessTitle || this.longTitle
		},
		shopLink() {
			return this.landingSettings?.shopLink
		},
		shopTitle() {
			return this.landingSettings?.shopTitle || 'وب سایت فروشگاه'
		}
	},
	methods: {
		toggleEditMode: call('app/toggleEditMode'),
		goToLogin() {
			router.push({ name: 'Login' }).catch(() => { })
		},
		routeToPlans() {
			// this.$route.params
			this.$router.replace('/cl/plans/' + (this.$route.params.customerCode ? this.$route.params.customerCode : '')).catch(() => { })
		},
		goToRegister() {
			router.push({ name: 'Register', params: { customerCode: this.$route.params.customerCode || 0 } }).catch(() => { })
		}
	},
}
</script>

<style lang="sass">
</style>
